"use client";

import { cn } from "@/lib/utils";

import { useCalendarContext } from "../calendar-context";
import { getEventColorClasses } from "../event-colors";
import { type DayBlock } from "../event-layout";
import { formatTime } from "../utils";

import { EventPopover } from "./event-popover";

// =============================================================================

/**
 * Single-day event of a month cell. Its height is its duration share of the
 * cell (flex-grow weight), with a readable floor.
 */
export function EventDayBlock({ block }: { block: DayBlock }) {
  const { locale } = useCalendarContext();
  const { event, weight } = block;

  return (
    <EventPopover event={event}>
      <button
        type="button"
        className={cn(
          "pointer-events-auto flex min-h-5 min-w-0 items-start gap-1 overflow-hidden rounded-md border px-1.5 py-0.5 text-left text-xs leading-4 font-medium transition-colors outline-none focus-visible:ring-2 focus-visible:ring-ring/40 focus-visible:ring-inset",
          getEventColorClasses(event.color).base
        )}
        style={{ flexBasis: 0, flexGrow: weight }}
      >
        {/* Below sm the block turns into a plain color strip */}
        <span className="truncate max-sm:sr-only">{event.title}</span>
        {!event.allDay && (
          <span className="ml-auto shrink-0 font-normal opacity-80 max-xl:hidden">
            {formatTime(event.start, locale)}
          </span>
        )}
      </button>
    </EventPopover>
  );
}
